/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileLite,
    CaseFileLiteFromJSON,
    CaseFileLiteFromJSONTyped,
    CaseFileLiteToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFilePage
 */
export interface CaseFilePage {
    /**
     * 
     * @type {Array<CaseFileLite>}
     * @memberof CaseFilePage
     */
    items?: Array<CaseFileLite> | null;
    /**
     * 
     * @type {number}
     * @memberof CaseFilePage
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseFilePage
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseFilePage
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseFilePage
     */
    totalItemCount?: number;
}

export function CaseFilePageFromJSON(json: any): CaseFilePage {
    return CaseFilePageFromJSONTyped(json, false);
}

export function CaseFilePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFilePage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(CaseFileLiteFromJSON)),
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'currentPage': !exists(json, 'currentPage') ? undefined : json['currentPage'],
        'itemsPerPage': !exists(json, 'itemsPerPage') ? undefined : json['itemsPerPage'],
        'totalItemCount': !exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
    };
}

export function CaseFilePageToJSON(value?: CaseFilePage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(CaseFileLiteToJSON)),
        'totalPages': value.totalPages,
        'currentPage': value.currentPage,
        'itemsPerPage': value.itemsPerPage,
        'totalItemCount': value.totalItemCount,
    };
}


